export enum Mfe {
  AA = 'dashboard_aa',
  ACCOUNT_CONFIGURATION = 'dashboard_account_configuration',
  CARE_CASE_MANAGEMENT = 'dashboard_care_case_management',
  COMPASS = 'dashboard_compass',
  DEVELOPER_EXPERIENCE = 'dashboard_developer_experience',
  DISPUTES = 'dashboard_disputes',
  DX = 'dashboard_dx',
  FEATURES = 'dashboard_features',
  FINCRIME_PAYMENT_INQUIRIES = 'dashboard_fincrime_payment_inquiries',
  FINLAB_BALANCES = 'dashboard_finlab_balances',
  FORWARD = 'dashboard_credential_forwarding',
  PAYMENT_INSTRUMENTS = 'dashboard_payment_instruments',
  FTS_REPORTING = 'dashboard_fts_reporting',
  ISSUING = 'dashboard_issuing',
  MARKETPLACE = 'dashboard_marketplace',
  NETWORK_TOKENS = 'dashboard_network_tokens',
  NOTIFICATIONS = 'dashboard_notifications',
  PLINK = 'dashboard_plink',
  PRISM = 'dashboard_prism',
  PROCESSING_CONFIGURATION = 'dashboard_processing_configuration',
  PROTUS = 'dashboard_protus',
  SETTLEMENTS = 'dashboard_settlements',
  TRANSACTIONS = 'dashboard_transactions',
  API_LOGS = 'dashboard_egw_api_logs',
}

export enum Team {
  AA = 'Account activation / Onboarding',
  ACCESS = 'Access',
  BALANCES = 'Balances',
  CORE = 'Portals Core',
  DEVELOPER_EXPERIENCE = 'Developer Experience',
  DISPUTES = 'Disputes',
  LIFECYCLE_CREDENTIALS = 'Lifecycle Credentials',
  FRAUD_DETECTION = 'Fraud Detection',
  INVOICES_FIN_REPORTING = 'Invoices and Financial Reporting',
  ISSUING = 'Issuing',
  MARKETPLACE = 'Marketplace',
  MERCHANT_CARE = 'Merchant Care',
  NOTIFICATIONS = 'Notifications',
  OCS_MCR = 'OCS - Merchant Change Requests',
  PAYMENT_INQ = 'Payment Inquiries',
  PAYMENT_LINKS = 'Payment Links',
  REPORTING_ANALYTICS = 'Reporting and Analytics',
  SETTLEMENTS = 'Client Settlements',
  TRANSACTIONS = 'Transactions',
  EDGE_GATEWAY = 'Edge Gateway',
}
